import request from '@/utils/request';
import { iResult, iUserInfo } from '@/interface/result';
import { iAdparams } from '@/interface/exchange-code';
import { AxiosPromise } from 'axios';
import { iExchangeCode, iCodeQuery, iChannelSearch } from '@/interface/exchange-code';
import { iTimeParams } from '@/interface/exchange-code';
import { iCloudUpdatePromotion, iCloudUpdateQuery } from '@/interface/cloud-update-promotion';
/**
 * 云更新推广活动列表 新增，修改
 * @param data iExchangeCode
 */
export const postCloudPromotion = (data: iCloudUpdatePromotion) =>
  request({
    url: '/api/v1/omc/marketing/promotion/create_or_edit',
    method: 'put',
    data,
  });

/**
 * 云更新推广活动列表列表
 * @param params iCodeQuery
 */
export const getCloudPromotion = (params: iCloudUpdateQuery) =>
  request({
    params,
    url: '/api/v1/omc/marketing/promotion/page_list',
  });
/**
 * 删除云更新推广活动
 */
export const deleteCloudPromotion = (params: any): Promise<any> =>
  request({
    params,
    url: `/api/v1/omc/marketing/promotion/delete`,
    method: 'delete',
  });
